export const aboveMobile = '768px';
export const aboveTablet = '980px';
export const desktop = '1200px';
export const largeDesktop = '1600px';
